import stakeableModel from 'models/stakeable-model';
import planModel from 'models/plan-model';
import {ClearButton, LockPinsButton, StakeableTitle, UndoButton} from 'views/stakeable/header-components';
import CloseButton from 'views/close-button';

// Button to crop the asset being edited
const CropButton = {
    view: () => {
        const doneLoading = !stakeableModel.state.isLoading;
        return <button class={`btn btn-crop btn btn-pill btn-small btn-not-primary ${!doneLoading ? ' btn-inactive' : ''}`} type='submit' onclick={doneLoading && (() => planModel.goToCropStep())}>
            <span class="btn-label"><i class="icon-crop"/>Crop Layer Image</span>
        </button>;
    }
};


// Continue to preview changes in staking flow
const NextButton = {
    view: () => {
        const minStakesReached = stakeableModel.state.minStakesReached;
        return <button class={`btn btn-small btn-next btn-primary btn-pill ${!minStakesReached ? ' btn-inactive' : ''}`} type='submit' onclick={minStakesReached && (() => planModel.nextFromStaking())}>
            <span class='btn-label'>Next</span>
        </button>;
    }
};

class PlanHeader {
    view() {
        return <div>
            <div class='stakeable-menu-controls layer-controls-close-view'>
                <CloseButton onclick={() => stakeableModel.close()} />
            </div>
            <div class='stakeable-menu-controls layer-controls-layer-title'>
                <StakeableTitle />
            </div>
            <div class='stakeable-menu-controls layer-controls-primary-ctas'>
                <LockPinsButton />
                <CropButton />
                <ClearButton />
                <UndoButton />
                <NextButton />
            </div>

        </div>;

    }

}

export default PlanHeader;
